export default {
  title: {
    id: 'seller_compensations_page_title',
    defaultMessage: 'Seller compensation',
  },
  description: {
    id: 'seller_compensations_page_description',
    defaultMessage:
      'Seller compensation is issued after a Seller Support Center (SSC) advisor approves an SSC claim that challenges a refund or action made by a BackCare agent.',
  },
  descriptionLink: {
    id: 'seller_compensations_page_description_link',
    defaultMessage: 'Learn more',
  },
  compensationNumberHeader: {
    id: 'seller_compensations_page_table_header_compensation_number',
    defaultMessage: 'Compensation number',
  },
  amountHeader: {
    id: 'seller_compensations_page_table_header_amount',
    defaultMessage: 'Amount (excl. tax)',
  },
  downloadPdfLink: {
    id: 'seller_compensations_page_table_download_pdf_link',
    defaultMessage: 'PDF',
  },
  salesTaxHeader: {
    id: 'seller_compensations_page_table_header_sales_tax',
    defaultMessage: 'Sales tax',
  },
  requestDateHeader: {
    id: 'seller_compensations_page_table_header_request_date',
    defaultMessage: 'Request date',
  },
  statusHeader: {
    id: 'seller_compensations_page_table_status',
    defaultMessage: 'Status',
  },
  downloadHeader: {
    id: 'seller_compensations_page_table_header_download',
    defaultMessage: 'Download',
  },
  noDataSurtitle: {
    id: 'seller_compensations_page_no_data_surtitle',
    defaultMessage: 'Nothing to see here.',
  },
  noDataTitle: {
    id: 'seller_compensations_page_no_data_title',
    defaultMessage: 'You haven’t received compensation yet.',
  },
  noDataDescription: {
    id: 'seller_compensations_page_no_data_description',
    defaultMessage:
      'If you think this might be an error, please get in touch with your Back Market point of contact.',
  },
  orderId: {
    id: 'seller_compensations_page_order_id',
    defaultMessage: 'Order Id',
  },
}
